import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiItem\CreateItemForWikiItemControlleur::__invoke
* @see app/Http/Controllers/WikiItem/CreateItemForWikiItemControlleur.php
* @route '/api/wiki-items/{wiki_item_id}/item-for-wiki-item'
*/
const CreateItemForWikiItemControlleur = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateItemForWikiItemControlleur.url(args, options),
    method: 'post',
})

CreateItemForWikiItemControlleur.definition = {
    methods: ["post"],
    url: '/api/wiki-items/{wiki_item_id}/item-for-wiki-item',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WikiItem\CreateItemForWikiItemControlleur::__invoke
* @see app/Http/Controllers/WikiItem/CreateItemForWikiItemControlleur.php
* @route '/api/wiki-items/{wiki_item_id}/item-for-wiki-item'
*/
CreateItemForWikiItemControlleur.url = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_item_id: args }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_item_id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_item_id: args.wiki_item_id,
    }

    return CreateItemForWikiItemControlleur.definition.url
            .replace('{wiki_item_id}', parsedArgs.wiki_item_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiItem\CreateItemForWikiItemControlleur::__invoke
* @see app/Http/Controllers/WikiItem/CreateItemForWikiItemControlleur.php
* @route '/api/wiki-items/{wiki_item_id}/item-for-wiki-item'
*/
CreateItemForWikiItemControlleur.post = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateItemForWikiItemControlleur.url(args, options),
    method: 'post',
})

export default CreateItemForWikiItemControlleur